import RestResource from '../rest.service';

export default class PlotTypesService extends RestResource {
  constructor() {
    super('plot-types');
  }
}
